import React from "react";

const SavedNewsPage = () => {
  return <div>SavedNewsPage</div>;
};

export default SavedNewsPage;
